/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Tab_MergeInputs */

const en_event_group_options_tab_merge = /** @type {(inputs: Event_Group_Options_Tab_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combine & Compare`)
};

const fr_event_group_options_tab_merge = /** @type {(inputs: Event_Group_Options_Tab_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combiner et comparer`)
};

const de_event_group_options_tab_merge = /** @type {(inputs: Event_Group_Options_Tab_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kombinieren und vergleichen`)
};

const it_event_group_options_tab_merge = /** @type {(inputs: Event_Group_Options_Tab_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combina e confronta`)
};

const ru_event_group_options_tab_merge = /** @type {(inputs: Event_Group_Options_Tab_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объединить и сравнить`)
};

const es_event_group_options_tab_merge = /** @type {(inputs: Event_Group_Options_Tab_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combinar y comparar`)
};

const zh_cn2_event_group_options_tab_merge = /** @type {(inputs: Event_Group_Options_Tab_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合并与比较`)
};

const ja_event_group_options_tab_merge = /** @type {(inputs: Event_Group_Options_Tab_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`組み合わせて比較`)
};

const hi_event_group_options_tab_merge = /** @type {(inputs: Event_Group_Options_Tab_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संयोजन और तुलना करें`)
};

const pt_pt2_event_group_options_tab_merge = /** @type {(inputs: Event_Group_Options_Tab_MergeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combine e compare`)
};

/**
* | output |
* | --- |
* | "Combine & Compare" |
*
* @param {Event_Group_Options_Tab_MergeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_tab_merge = /** @type {((inputs?: Event_Group_Options_Tab_MergeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Tab_MergeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_group_options_tab_merge(inputs)
	if (locale === "de") return de_event_group_options_tab_merge(inputs)
	if (locale === "it") return it_event_group_options_tab_merge(inputs)
	if (locale === "ru") return ru_event_group_options_tab_merge(inputs)
	if (locale === "es") return es_event_group_options_tab_merge(inputs)
	if (locale === "zh-CN") return zh_cn2_event_group_options_tab_merge(inputs)
	if (locale === "ja") return ja_event_group_options_tab_merge(inputs)
	if (locale === "hi") return hi_event_group_options_tab_merge(inputs)
	if (locale === "pt-PT") return pt_pt2_event_group_options_tab_merge(inputs)
	return en_event_group_options_tab_merge(inputs)
});